<p mat-dialog-title class="!m-0">{{ data.title }}</p>
<div
  mat-dialog-content
  style="color: black; font-weight: 200; font-size: 1rem !important"
  [innerHTML]="data.message"></div>
<div
  mat-dialog-actions
  [ngClass]="{
    'flex-button-end': data.direction === 'end',
    'flex-button-start': data.direction === 'start'
  }">
  <button
    color="primary"
    class="uppercase-button"
    *ngIf="data.showButtons.cancel"
    mat-button
    [mat-dialog-close]="false"
    (click)="cancel()">
    {{ data.buttonsName.cancel }}
  </button>
  <button
    color="primary"
    class="uppercase-button"
    *ngIf="data.showButtons.accept"
    mat-button
    [mat-dialog-close]="true"
    (click)="confirm()"
    cdkFocusInitial>
    {{ data.buttonsName.accept }}
  </button>
</div>
